import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField } from '@mui/material';
import { Edit, Delete, Visibility } from '@mui/icons-material';
import { Deanery } from '../../types';

interface DeaneriesTableProps {
  deaneries: Deanery[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (deanery: Deanery) => void;
  onDelete: (id: number) => void;
}

export function DeaneriesTable({ deaneries, loading, total, page, limit, onPageChange, onEdit, onDelete }: DeaneriesTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Описание</TableCell>
            <TableCell>Координатор</TableCell>
            <TableCell>Храмов</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deaneries.map((deanery) => (
            <TableRow key={deanery.id} hover>
              <TableCell>{deanery.name}</TableCell>
              <TableCell>{deanery.description || '-'}</TableCell>
              <TableCell>{deanery.coordinator?.name || '-'}</TableCell>
              <TableCell>{deanery.temples?.length || 0}</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр"><IconButton size="small"><Visibility fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(deanery)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(deanery.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {deaneries.length === 0 && !loading && (
            <TableRow><TableCell colSpan={5} align="center"><Typography color="text.secondary">Благочиния не найдены</Typography></TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, newPage) => onPageChange(newPage + 1)} rowsPerPage={limit} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}

interface DeaneriesToolbarProps { search: string; onSearchChange: (value: string) => void; }
export function DeaneriesToolbar({ search, onSearchChange }: DeaneriesToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
      <TextField label="Поиск" variant="outlined" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 200 }} />
    </Box>
  );
}
